module.exports = __webpack_public_path__ + "img/memoirerings.b488e0d.jpg";